import { render, staticRenderFns } from "./main_profile.vue?vue&type=template&id=62fe1421&scoped=true&"
import script from "./main_profile.vue?vue&type=script&lang=js&"
export * from "./main_profile.vue?vue&type=script&lang=js&"
import style0 from "./main_profile.vue?vue&type=style&index=0&id=62fe1421&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe1421",
  null
  
)

export default component.exports